export default __webpack_public_path__ + "static/media/404.554a2c39.png";